/**
=========================================================
* Lex Go - v2.1.1 (routes)
=========================================================
*/

// @mui material components
import Icon from "@mui/material/Icon";

// Pages
import Presentation from "layouts/pages/presentation";
import ComingSoon from "pages/coming-soon";

const routes = [
  // ANA SAYFA (Aynen kalsın)
  {
    name: "Ana Sayfa",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Presentation />,
  },

  // HİZMETLER (Hepsi ComingSoon)
  {
    name: "Hizmetler",
    icon: <Icon>gavel</Icon>,
    columns: 2,
    rowsPerColumn: 3,
    collapse: [
      {
        name: "Ücretsiz Şablonlar",
        dropdown: true,
        collapse: [
          { name: "Kira Sözleşmesi", route: "/hizmetler/ucretsiz/kira", component: <ComingSoon /> },
          { name: "İş Sözleşmesi", route: "/hizmetler/ucretsiz/is", component: <ComingSoon /> },
          { name: "Gizlilik (NDA)", route: "/hizmetler/ucretsiz/nda", component: <ComingSoon /> },
          {
            name: "Ortaklık Sözleşmesi",
            route: "/hizmetler/ucretsiz/ortaklik",
            component: <ComingSoon />,
          },
        ],
      },
      {
        name: "Premium Paketler",
        dropdown: true,
        collapse: [
          {
            name: "Girişimci Paketi",
            route: "/hizmetler/premium/girisimci",
            component: <ComingSoon />,
          },
          { name: "İK Paketi", route: "/hizmetler/premium/ik", component: <ComingSoon /> },
        ],
      },
    ],
  },

  // REHBERLER & BLOG (Hepsi ComingSoon)
  {
    name: "Rehberler & Blog",
    icon: <Icon>library_books</Icon>,
    columns: 2,
    rowsPerColumn: 2,
    collapse: [
      { name: "Hukuki Bilgiler", route: "/rehberler/hukuki-bilgiler", component: <ComingSoon /> },
      {
        name: "Yargıtay Kararları Özeti",
        route: "/rehberler/yargitay-ozetleri",
        component: <ComingSoon />,
      },
      {
        name: "Start-up Hukuku Notları",
        route: "/rehberler/startup-hukuku",
        component: <ComingSoon />,
      },
      { name: "Yazarlar", route: "/rehberler/yazar", component: <ComingSoon /> },
    ],
  },

  // HAKKIMIZDA (Hepsi ComingSoon)
  {
    name: "Hakkımızda",
    icon: <Icon>info</Icon>,
    collapse: [
      { name: "Misyonumuz", route: "/hakkimizda/misyon", component: <ComingSoon /> },
      { name: "Neden LexGo?", route: "/hakkimizda/neden-lexgo", component: <ComingSoon /> },
    ],
  },

  // İLETİŞİM (Hepsi ComingSoon)
  {
    name: "İletişim",
    icon: <Icon>support_agent</Icon>,
    collapse: [
      { name: "İletişim Formu", route: "/iletisim/form", component: <ComingSoon /> },
      { name: "WhatsApp Hızlı Erişim", route: "/iletisim/whatsapp", component: <ComingSoon /> },
      { name: "Sosyal Medya & Abonelik", route: "/iletisim/abonelik", component: <ComingSoon /> },
    ],
  },
];

export default routes;
